import { FilterTable } from "@/features/FilterTable/FilterTable";
import { Field } from "@/features/FilterTable/types";
import { dateSchema, parseToDateValue } from "@/features/FormCard/utils";
import { z } from "zod";

//
// Filter schema
//
export const filterInputFilesSchema = z.object({
  protocol_contains: z.string().nullable().optional(),
  connector_contains: z.string().nullable().optional(),
  connector_config_id: z.string().nullable().optional(),
  path_contains: z.string().nullable().optional(),
  filename_contains: z.string().nullable().optional(),
  gmail_labels_contains: z.string().nullable().optional(),
  created_at_from: z
    .preprocess((val) => parseToDateValue(val as string), dateSchema)
    .optional(),
  created_at_to: z
    .preprocess((val) => parseToDateValue(val as string), dateSchema)
    .optional(),
  updated_at_from: z
    .preprocess((val) => parseToDateValue(val as string), dateSchema)
    .optional(),
  updated_at_to: z
    .preprocess((val) => parseToDateValue(val as string), dateSchema)
    .optional(),
});

export type FilterInputFilesSchema = z.infer<typeof filterInputFilesSchema>;

//
// Field definitions
//
export const fields: Field[] = [
  {
    name: "protocol_contains",
    label: "Protocol",
    type: "input",
  },
  {
    name: "connector_contains",
    label: "Connector",
    type: "input",
  },
  {
    name: "connector_config_id",
    label: "Connector Config",
    type: "input",
  },
  {
    name: "path_contains",
    label: "Path",
    type: "input",
  },
  {
    name: "filename_contains",
    label: "Filename",
    type: "input",
  },
  {
    name: "gmail_labels_contains",
    label: "Gmail Labels",
    type: "input",
  },
  {
    name: "created_at_from",
    label: "Created From",
    type: "date",
  },
  {
    name: "created_at_to",
    label: "Created To",
    type: "date",
  },
  {
    name: "updated_at_from",
    label: "Updated From",
    type: "date",
  },
  {
    name: "updated_at_to",
    label: "Updated To",
    type: "date",
  },
];

export const client = "qtl - etl";

export function FilterInputFiles() {
  return (
    <FilterTable
      client={client}
      schema={filterInputFilesSchema}
      tableName="input_files"
      customBuildPath={() => `${client}/input_files`}
      fields={fields}
      columns={2}
    />
  );
}
